export default {
    beforeCreate() {
        if (this.useLocalStore) {
            this.computed = {}
            this.computed.doTest = function() { return "Hi Test" }
        }
    }
}
